/**
 * Strips inline markdown emphasis markers (`**bold**`, `*italic*`,
 * `__bold__`, `_italic_`) that BE-generated copy occasionally carries, so
 * plain-text surfaces don't render literal asterisks/underscores. Block
 * markdown is out of scope — these fields are prose, not documents.
 */
export function stripInlineMarkdown(text: string): string {
  return text
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    .replace(/(?<!\*)\*(?!\s)(.+?)(?<!\s)\*(?!\*)/g, '$1')
    .replace(/(?<![A-Za-z0-9_])_(?!\s)(.+?)(?<!\s)_(?![A-Za-z0-9_])/g, '$1');
}
